import { DIV, H1, H2 } from 'sdi/components/elements';
import tr, { Translated } from 'sdi/locale';
import {
    getForm,
    getFormComment,
    getValidFormComment,
    getFormSource,
} from 'qa/src/queries/osm';
import { fst, snd } from 'sdi/lib';
import { inputLongText } from 'sdi/components/input';
import {
    addFormTag,
    changeFormComment,
    // changeFormKey,
    // changeFormValue,
    changeTagState,
    deleteFormTag,
    submitFormTag,
    changeFormSource,
} from 'qa/src/events/osm';
import { Tag } from 'qa/src/remote';
import {
    renderButtonAddTag,
    cancelButton,
    renderButtonCancelTagDelete,
    renderButtonDelete,
    saveButton,
} from '../buttons';
import { divTooltipRight, divTooltipTopLeft } from 'sdi/components/tooltip';

const renderEditableTag = (tag: Tag, index: number) => {
    const k = fst(tag.pair);
    const v = snd(tag.pair);
    return DIV(
        { className: `tag tag-input ${tag.state}` },
        k,
        v,
        // inputText(
        //     () => k,
        //     k => changeFormKey(k, index),
        //     {
        //         className: 'key',
        //         value: k,
        //         key: `tag-form-key ${index}`,
        //     }
        // ),
        // inputText(
        //     () => v,
        //     v => changeFormValue(v, index),
        //     {
        //         className: 'value',
        //         value: v,
        //         key: `tag-form-value ${index}`,
        //     }
        // ),
        divTooltipTopLeft(
            'Supprimer le tag' as Translated,
            {},
            renderButtonDelete(() =>
                tag.state === 'created'
                    ? deleteFormTag(index)
                    : changeTagState('deleted', index)
            )
        )
    );
};

const renderDeletedTag = (tag: Tag, index: number) => {
    const k = fst(tag.pair);
    const v = snd(tag.pair);
    return DIV(
        { className: `tag tag-input ${tag.state}` },
        DIV(
            {
                className: 'key',
                value: k,
                key: `tag-form-key ${index}`,
            },
            k
        ),
        DIV(
            {
                className: 'value',
                value: v,
                key: `tag-form-value ${index}`,
            },
            v
        ),
        renderButtonCancelTagDelete(() => changeTagState('none', index))
    );
};

const renderTag = (tag: Tag, index: number) =>
    tag.state === 'deleted'
        ? renderDeletedTag(tag, index)
        : renderEditableTag(tag, index);

const renderAddComment = () =>
    DIV(
        { className: 'tag-comment' },
        H2(
            { className: 'tag-comment-title' },
            `${tr.qa('changesetComment')} (min. 2 mots)`
        ),
        // SPAN({ className: 'tag-comment-helper' }, '(min. 2 mots)'),
        inputLongText(getFormComment, changeFormComment, {
            className: 'value',
            key: `tag-form-value comment`,
            placeholder: tr.qa('addTagChangeSetMsg'),
            rows: 8,
        })
    );

const renderAddSource = () =>
    DIV(
        { className: 'tag-source' },
        H2({ className: 'tag-source-title' }, tr.qa('changesetSource')),
        inputLongText(getFormSource, changeFormSource, {
            className: 'value',
            key: `tag-form-value source`,
            placeholder: tr.qa('addTagSource'),
            rows: 4,
        })
    );

const header = () => H1({}, 'Éditer les tags');

const footer = (close: () => void) =>
    DIV(
        {},
        getValidFormComment().foldL(
            () => saveButton(() => {}, 'disabled'),
            () =>
                saveButton(() => {
                    submitFormTag();
                    close();
                })
        ),
        cancelButton(close)
    );

const body = () => {
    return DIV(
        { className: 'tag-editor' },
        DIV(
            { className: 'tag-input-wrapper' },
            H2({ className: 'tag-input-title' }, 'Tags'),
            getForm().map(t =>
                t.tags.map((tag, index) => renderTag(tag, index))
            ),
            divTooltipRight(
                'créer un nouveau tag' as Translated,
                {},
                renderButtonAddTag(() => addFormTag())
            )
        ),
        DIV(
            { className: 'tag-messages' },
            renderAddSource(),
            renderAddComment()
        )
    );
};

export const renderTagsEditor = { header, body, footer };
